import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { updateEstado } from "../../../redux/actions";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import Button from "../../../components/button";

function CambiarEstadoComponent({ onCloseEstado, puedeCompactar, refreshDetalle }) {
  const dispatch = useDispatch();
  let { id } = useParams();

  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const openErrorModal = (message) =>
    setErrorModal({ show: true, message });

  const closeErrorModal = () =>
    setErrorModal({ show: false, message: "" });

  const {
    register,
    handleSubmit,
  } = useForm();

  const onSubmit = async (data, event) => {
    event.preventDefault();

    setLoading(true);

    const finalData = { ...data, id: id };

    try {
      const response = await dispatch(updateEstado(finalData));

      if (response) {
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error(error);

      const serverErrorMessage =
        error.response?.data?.error ||
        "Error inesperado al actualizar el estado.";

      openErrorModal(serverErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccessModal(false);
    refreshDetalle();
    onCloseEstado();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onCloseEstado}
    >
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={handleCloseSuccess}
          message="Estado actualizado con éxito."
        />
      )}

      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}

      <div className="relative">
        <button
          onClick={onCloseEstado}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        <form
          onSubmit={handleSubmit(onSubmit)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-[20rem] bg-white p-6 rounded-lg shadow-lg">
            <div className="text-2xl font-bold mb-4 text-center">
              Cambiar Estado
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estado
              </label>

              {(tipoCurrentUser === "admin" ||
                tipoCurrentUser === "super_admin") ? (
                <select
                  className="w-full p-2 border rounded"
                  {...register("estado", {
                    required: "Seleccione un estado por favor",
                  })}
                >
                  <option value="" disabled>
                    Seleccionar un estado
                  </option>

                  <option value="Ingresado">Ingresado</option>
                  <option value="Desconocido">Desconocido</option>
                  <option value="No compactar">
                    No compactar
                  </option>

                  <option
                    value="A compactar"
                    disabled={!puedeCompactar}
                    className={
                      !puedeCompactar
                        ? "text-gray-400 italic"
                        : ""
                    }
                    title={
                      !puedeCompactar
                        ? "No se puede cambiar a este estado por ahora"
                        : ""
                    }
                  >
                    {puedeCompactar
                      ? "A compactar"
                      : "A compactar (bloqueado por juzgado)"}
                  </option>
                </select>
              ) : (
                <select
                  className="w-full p-2 border rounded"
                  {...register("estado", {
                    required: "Seleccione un estado por favor",
                  })}
                >
                  <option value="" disabled>
                    Seleccionar un estado
                  </option>

                  <option value="Ingresado">Ingresado</option>
                  <option value="Desconocido">Desconocido</option>
                </select>
              )}
            </div>

            <div className="flex flex-col justify-center gap-4">
              <Button type="submit" fullWidth loading={loading}>
                Guardar
              </Button>

              <Button
                type="button"
                variant="secondary"
                fullWidth
                disabled={loading}
                onClick={onCloseEstado}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CambiarEstadoComponent;